<template>
    <div>
      <div class="page-container block-f">
        <div class="text-h5 text-center font-weight-bold mb-10 pb-5">{{ $t('PackageC.name') }}</div>
        <!-- <div class="text-h5 text-center font-weight-bold mb-15 pb-5">{{ $t('Research.Title') }}</div> -->
        <v-row class="d-flex justify-space-around align-center">
            <v-col  sm="6" md="6" lg="4">
                <v-card :height="newsil8n=='en'? 820 : 630" class="py-6" style="background-color:rgb(251, 249, 246);">
                    <span></span>
                    <div class="package-tip d-flex justify-center align-center ">
                        <div class="text-subtitle-1 font-weight-bold text-center">{{ $t('PackageC.package') }}</div>
                    </div>
                    <div class="px-5 mt-6">
                        <div class="d-flex justify-space-between align-center">
                            <div style="max-width:50%" class="text-body-2 font-weight-bold">{{ $t('PackageC.planA.name') }}</div>
                        </div>
                        <v-divider class="my-6"></v-divider>
                        <div class="d-flex justify-center align-center">
                            <img width="60px" src="../../assets/images/usdt.png" alt="usdt">
                            <div class="text-h5 font-weight-bold text-center pl-4">{{ $t('PackageC.frequency') }}</div>
                        </div>
                        <div v-if="newsil8n=='en'" class="d-flex flex-column justify-center align-center mt-6">
                            <div class="grey--text text-subtitle-1 font-weight-medium">{{ $t('PackageC.buy1') }}</div>
                            <v-btn href="https://dapp.supercells.pro/swap" depressed height="24" color="red" class="white--text font-weight-regular pa-2 mt-4">{{ $t('PackageC.discount1') }}</v-btn>
                        </div>
                        <div v-else class="d-flex justify-space-between align-center mt-6">
                            <div class="grey--text text-subtitle-1 font-weight-medium">{{ $t('PackageC.buy1') }}</div>
                            <v-btn href="https://dapp.supercells.pro/swap" depressed height="24" color="red" class="white--text font-weight-regular pa-2">{{ $t('PackageC.discount1') }}</v-btn>
                        </div>
                        <div v-if="newsil8n=='en'" class="d-flex flex-column justify-center align-center mt-1">
                            <div class="grey--text text-subtitle-1 font-weight-medium mt-4">{{ $t('PackageC.buy2') }}</div>
                            <v-btn  href="https://dapp.supercells.pro/swap" depressed height="24" color="#A09079" class="white--text font-weight-regular pa-2 mt-4">{{ $t('PackageC.discount2') }}</v-btn>
                        </div>
                        <div v-else class="d-flex justify-space-between align-center mt-1">
                            <div class="grey--text text-subtitle-1 font-weight-medium">{{ $t('PackageC.buy2') }}</div>
                            <v-btn  href="https://dapp.supercells.pro/swap" depressed height="24" color="#A09079" class="white--text font-weight-regular pa-2">{{ $t('PackageC.discount2') }}</v-btn>
                        </div>
                        <v-divider class="my-6"></v-divider>
                        <div class="mt-1">
                            <div class="d-flex align-center">
                                <div class="point"></div>
                                <div class="text-body-2 font-weight-bold">{{ $t('PackageC.con1') }}</div>
                            </div>
                            <div class="text-caption font-weight-medium">
                                {{ $t('PackageC.con1text') }}
                            </div>
                        </div>
                        <div class="d-flex justify-space-between align-center mt-1">
                            <div class="d-flex align-center">
                                <div class="point"></div>
                                <div class="text-body-2 font-weight-bold">{{ $t('PackageC.con2') }}</div>
                            </div>
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
      </div>
      <Footer></Footer>
    </div>
</template>

<script>
import Footer from '../../components/Footer.vue'


export default {
  components: {
    Footer
  },
 data:() => ({
    newsil8n:null,
    }),
  mounted(){
    this.newsil8n = this.$i18n.locale
  },
  watch:{
        '$i18n.locale'(newil8n){
        console.log(newil8n);
        this.newsil8n=newil8n;
        }
    },
}
</script>

<style>
.v-card > div{
    border-bottom-left-radius: none !important;
    border-bottom-right-radius: none !important;
}

  .page-container {
    min-height: calc(100vh - 289px);
    padding: 120px;
    background: #F8F4F0;
  }
  .package-tip{
    border-bottom-left-radius: none !important;
    border-bottom-right-radius: none !important;
    width: 200px;
    height: 40px;
    background: rgb(160, 144, 121);
    position: relative;
    color: #333;
  }
  .package-tip::after{
    position: absolute;
    content: "";
    width: 0;
    height: 40px;
    top: 0;
    right: -40px;
    border-width: 20px;
    border-style: solid;
    border-color:  transparent  transparent transparent rgb(160, 144, 121);
  }
  .text-color{
    color: #AC8250 !important;
  }
  .point{
    width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color:  transparent transparent transparent rgb(160, 144, 121);
  }

  @media screen and (max-width: 960px) {
    .about {
      padding: 30px 24px;
    }
    .page-container {
        min-height: calc(100vh - 266px);
        padding: 80px 24px 30px;
    }
  }
</style>
  